import { useState } from 'react'

import { KTIcon } from '../../../_metronic/helpers'
import { SmartTooltip } from '../../../components/SmartTooltip/SmartTooltip'
import { ClientSnapshotCard, ClientSnapshotState } from './ClientSnapshotCard'
import { getClientSnapshot } from './core/_requests'

type Props = {
  /** Токен учётки клиента. */
  token: string
  /** Депозит строки: оценка считается для него, как строка «Клиент» его антифрод-сигнала. */
  paymentTicketToken?: string | null
}

/**
 * Иконка клиента рядом с его идентификатором: по наведению — снимок сквозного клиента. Снимок
 * грузится при первом наведении, а не вместе с таблицей.
 */
export const ClientSnapshotIcon = ({ token, paymentTicketToken }: Props) => {
  const [state, setState] = useState<ClientSnapshotState | null>(null)

  const load = () => {
    if (state !== null && state.status !== 'error') {
      return
    }
    setState({ status: 'loading' })
    getClientSnapshot(token, paymentTicketToken)
      .then((snapshot) => setState({ status: 'ready', snapshot }))
      .catch(() => setState({ status: 'error' }))
  }

  return (
    <SmartTooltip content={<ClientSnapshotCard state={state ?? { status: 'loading' }} />} bare maxWidth={480} maxHeight={640}>
      <span
        data-testid='client-snapshot-icon'
        aria-label='Снимок клиента'
        onMouseEnter={load}
        onFocus={load}
        tabIndex={0}
        style={{ cursor: 'default', marginLeft: 4, verticalAlign: 'middle' }}
      >
        <KTIcon iconName='profile-circle' className='fs-5 text-gray-600' />
      </span>
    </SmartTooltip>
  )
}
